/**
 * Contact form API functions
 */

import { ContactFormData, ContactSubmissionResponse } from '../types/contact';
import { STRAPI_URL } from './base';

/**
 * Submit contact form to Strapi
 */
export async function submitContactForm(
  formData: ContactFormData
): Promise<ContactSubmissionResponse> {
  try {
    const response = await fetch(`${STRAPI_URL}/api/contacts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: formData,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Contact form submission error:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
      });

      // Try to parse error message from response
      let errorMessage = `HTTP error! status: ${response.status} - ${response.statusText}`;
      try {
        const errorData = JSON.parse(errorText);
        if (errorData.error?.message) {
          errorMessage = errorData.error.message;
        }
      } catch {
        // If parsing fails, use the raw error text if it's meaningful
        if (errorText && errorText.length < 200) {
          errorMessage = errorText;
        }
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
}
